import styled from "styled-components";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const ClientDetailsContainer = styled.div`
  width: 100%;
  margin-bottom: 2em;
`;

export const ClientDetailsRow = styled.div`
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr) max-content;
  column-gap: 1.5em;
  align-items: center;
  padding: 0.2em 1.75em 0.2em 0.75em;
  margin-left: 1em;
  border-bottom: 1px solid ${colours.elexonBlue};

  &:first-child {
    border-top: 1px solid ${colours.elexonBlue};
  }

  > :last-child {
    justify-self: end;
    align-self: center;
    display: flex;
    align-items: center;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: 0.5em;

    > :last-child {
      justify-self: start;
    }
  }
`;

export const Label = styled.span`
  font-weight: ${fontWeights.bold};
  color: ${colours.elexonBlack};
`;

export const Value = styled.span`
  color: ${colours.darkGrey};
  word-break: break-word;
`;
